import DailyCartItem from "./DailyCartItem";

export default DailyCartItem;
